import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { StarIcon, XIcon, MessageSquareIcon, LoaderIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
// ⬇️ REPLACE THIS with your deployed Google Apps Script Web App URL
const GOOGLE_SHEET_URL = 'https://script.google.com/macros/s/AKfycbyqrPuJ00OvNziyxfKYsQm5B7PDQ_NokknZuPY1SM0VNTaXpfbPNVmWpkONV3F9fMGV9A/exec';
export function FeedbackPopup() {
  const {
    language
  } = useLanguage();
  const isEs = language === 'ES';
  const [isVisible, setIsVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [comment, setComment] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [city, setCity] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  useEffect(() => {
    // Check localStorage
    const submitted = localStorage.getItem('haa-feedback-submitted');
    if (submitted) return;
    const dismissed = localStorage.getItem('haa-feedback-dismissed');
    if (dismissed) {
      const dismissTime = parseInt(dismissed, 10);
      const sevenDays = 7 * 24 * 60 * 60 * 1000;
      if (Date.now() - dismissTime < sevenDays) {
        return;
      }
    }
    // Show after 20 seconds
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 20000);
    return () => clearTimeout(timer);
  }, []);
  const handleDismiss = () => {
    setIsVisible(false);
    setIsOpen(false);
    // Reappear after 3 minutes if not submitted
    setTimeout(() => {
      const alreadySubmitted = localStorage.getItem('haa-feedback-submitted');
      if (!alreadySubmitted) {
        setIsVisible(true);
      }
    }, 3 * 60 * 1000);
  };
  const handleSubmit = async () => {
    if (rating === 0 || isSubmitting) return;
    setIsSubmitting(true);
    try {
      await fetch(GOOGLE_SHEET_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          rating,
          comment,
          state: selectedState,
          city,
          language
        })
      });
    } catch (err) {
      console.error('Feedback submission error:', err);
    }
    setIsSubmitting(false);
    setIsSubmitted(true);
    localStorage.setItem('haa-feedback-submitted', 'true');
    setTimeout(() => {
      setIsOpen(false);
      setIsVisible(false);
    }, 2000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-6 left-6 z-[90] flex flex-col items-start" data-id="element-1396">
      <AnimatePresence mode="wait" data-id="element-1397">
        {!isOpen ? <motion.button key="trigger" initial={{
        opacity: 0,
        scale: 0.8,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.8,
        y: 20
      }} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} onClick={() => setIsOpen(true)} className="bg-white text-haa-navy font-nunito font-bold text-sm px-4 py-3 rounded-full shadow-lg border border-gray-200 flex items-center gap-2 hover:shadow-xl transition-shadow" data-id="element-1398">
            <span className="text-amber-400 text-lg leading-none -mt-1" data-id="element-1399">★</span>
            {isEs ? 'Opinión' : 'Feedback'}
          </motion.button> : <motion.div key="card" initial={{
        opacity: 0,
        scale: 0.9,
        y: 20,
        originX: 0,
        originY: 1
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.9,
        y: 20
      }} className="bg-white rounded-2xl shadow-2xl border border-gray-100 w-[320px] overflow-hidden flex flex-col" data-id="element-1400">
            {/* Header */}
            <div className="bg-gradient-to-r from-haa-blue to-haa-skyblue px-5 py-3 flex items-center justify-between" data-id="element-1401">
              <div className="flex items-center gap-2 text-white" data-id="element-1402">
                <MessageSquareIcon className="w-4 h-4" data-id="element-1403" />
                <span className="font-nunito font-bold text-sm" data-id="element-1404">
                  {isEs ? 'Tu Opinión' : 'Your Feedback'}
                </span>
              </div>
              <button onClick={handleDismiss} className="text-white/80 hover:text-white transition-colors p-1" aria-label="Close" data-id="element-1405">
                <XIcon className="w-4 h-4" data-id="element-1406" />
              </button>
            </div>

            {/* Content */}
            <div className="p-5" data-id="element-1407">
              {isSubmitted ? <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} className="flex flex-col items-center justify-center py-6 text-center" data-id="element-1408">
                  <div className="w-12 h-12 rounded-full bg-emerald-100 flex items-center justify-center mb-3" data-id="element-1409">
                    <svg className="w-6 h-6 text-emerald-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} data-id="element-1410">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-1411" />
                    </svg>
                  </div>
                  <p className="font-nunito font-bold text-haa-navy" data-id="element-1412">
                    {isEs ? '¡Gracias por tu opinión!' : 'Thank you for your feedback!'}
                  </p>
                </motion.div> : <div className="flex flex-col gap-4" data-id="element-1413">
                  <p className="font-nunito text-sm text-gray-600 text-center font-semibold" data-id="element-1414">
                    {isEs ? '¿Cómo es tu experiencia?' : "How's your experience?"}
                  </p>

                  {/* Star Rating */}
                  <div className="flex items-center justify-center gap-1" data-id="element-1415">
                    {[1, 2, 3, 4, 5].map(star => <button key={star} type="button" onClick={() => setRating(star)} onMouseEnter={() => setHoverRating(star)} onMouseLeave={() => setHoverRating(0)} className="p-1 focus:outline-none transition-transform hover:scale-110" data-id="element-1416">
                        <StarIcon className={`w-8 h-8 transition-colors ${(hoverRating || rating) >= star ? 'fill-haa-skyblue text-haa-skyblue' : 'fill-transparent text-gray-300'}`} data-id="element-1417" />
                      </button>)}
                  </div>

                  {/* State Dropdown */}
                  <select value={selectedState} onChange={e => setSelectedState(e.target.value)} className="w-full px-3 py-2.5 rounded-xl border border-gray-200 focus:border-haa-blue focus:ring-2 focus:ring-haa-blue/20 outline-none transition-all font-nunito text-sm bg-white text-gray-700" data-id="element-1418">
                    <option value="" data-id="element-1419">
                      {isEs ? '-- Selecciona tu estado --' : '-- Select your state --'}
                    </option>
                    {['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming', 'District of Columbia', 'Puerto Rico', 'U.S. Virgin Islands', 'Guam', 'American Samoa', 'Northern Mariana Islands'].map(s => <option key={s} value={s} data-id="element-1420">
                        {s}
                      </option>)}
                  </select>

                  {/* City */}
                  <input type="text" value={city} onChange={e => setCity(e.target.value)} placeholder={isEs ? 'Ciudad (opcional)' : 'City (optional)'} className="w-full px-3 py-2.5 rounded-xl border border-gray-200 focus:border-haa-blue focus:ring-2 focus:ring-haa-blue/20 outline-none transition-all font-nunito text-sm bg-white" data-id="element-1421" />

                  {/* Feedback Prompt */}
                  <p className="font-nunito text-xs text-gray-500 text-center leading-relaxed" data-id="element-1422">
                    {isEs ? 'Comentarios generales: ¿Cómo podemos mejorar este sitio? ¿Qué te gustaría ver más?' : 'General Feedback: How can we make this site better? What would you like to see more of?'}
                  </p>

                  {/* Comment */}
                  <textarea value={comment} onChange={e => setComment(e.target.value)} placeholder={isEs ? 'Deja un comentario (opcional)' : 'Leave a comment (optional)'} className="w-full px-3 py-2 rounded-xl border border-gray-200 focus:border-haa-blue focus:ring-2 focus:ring-haa-blue/20 outline-none transition-all font-nunito text-sm resize-none h-20" data-id="element-1423" />

                  {/* Submit */}
                  <button onClick={handleSubmit} disabled={rating === 0 || isSubmitting} className="w-full py-2.5 bg-haa-navy hover:bg-haa-blue text-white font-nunito font-bold text-sm rounded-xl transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2" data-id="element-1424">
                    {isSubmitting ? <>
                        <LoaderIcon className="w-4 h-4 animate-spin" data-id="element-1425" />
                        {isEs ? 'Enviando...' : 'Sending...'}
                      </> : isEs ? 'Enviar' : 'Submit'}
                  </button>
                </div>}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}